import { useTranslation } from 'react-i18next';
import CheckCircleIcon from 'assets/images/icons/check-circle.svg?react';
import CircleIcon from 'assets/images/icons/circle.svg?react';

interface BookingDotComQualityScoreDoneCheckProps {
  done: boolean;
}

const BookingDotComQualityScoreDoneCheck = ({
  done,
}: BookingDotComQualityScoreDoneCheckProps) => {
  const { t } = useTranslation();

  return (
    <span className={`state ${done ? 'done' : ''}`}>
      {done ? (
        <>
          {t('pageProperty.reviews.bookingDotCom.done')}
          <CheckCircleIcon />
        </>
      ) : (
        <CircleIcon />
      )}
    </span>
  );
};

export default BookingDotComQualityScoreDoneCheck;
